export default function PortfolioCTA() {
  const handleContactClick = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/kontakt');
    }
  };

  return (
    <section className="py-20 lg:py-32 bg-black border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 lg:mb-8 leading-tight">
            Bereit für Ihr eigenes Projekt?
          </h2>
          <p className="text-white/60 text-base lg:text-lg xl:text-xl mb-10 lg:mb-12 max-w-2xl mx-auto leading-relaxed">
            Lassen Sie uns gemeinsam eine Website erstellen, die Ihre Kunden begeistert 
            und Ihr Unternehmen erfolgreich macht.
          </p>
          <button 
            onClick={handleContactClick}
            className="group inline-flex items-center space-x-3 bg-white text-black px-8 lg:px-10 py-4 lg:py-5 text-sm lg:text-base uppercase tracking-wider font-medium hover:bg-[#d1bc8a] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span>Jetzt Projekt starten</span>
            <i className="ri-arrow-right-line text-lg lg:text-xl transform group-hover:translate-x-1 transition-transform duration-300"></i>
          </button>
        </div>
      </div>
    </section>
  );
}